import { checkFeatureFlagGate } from '@/utils/feature-flags/check-feature-flag';
import { featureFlags } from '@/utils/feature-flags/feature-flag-manifest';

import { isProductCollectionSignupEnabled } from './is-product-collection-signup-enabled';

/**
 * JPD signup redirects to Product Collection signup with the wac_jpd_to_product_collection_redirect
 * gate (STARB-4844). Product Collection signup must also be enabled, otherwise the
 * product-collection bundle does not resolve and the user would land on the default Jira signup.
 * The redirect gate is checked last so exposures are only logged for users who can be redirected.
 */
export const isJpdToProductCollectionRedirectEnabled = (): boolean =>
	isProductCollectionSignupEnabled() &&
	checkFeatureFlagGate(featureFlags.wacJpdToProductCollectionRedirect);
